// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"_payment-SubmitButton-module--submit-button--1HCNl","applePay":"_payment-SubmitButton-module--apple-pay--3o1go"};